(function (XHR) {
  "use strict";

  var open = XHR.prototype.open;
  var send = XHR.prototype.send;

  XHR.prototype.open = function (method, url, async, user, pass) {
    this._url = url;
    open.call(this, method, url, async, user, pass);
  };

  XHR.prototype.send = function (data) {
    var self = this;
    var url = this._url;

    if (
      url &&
      url.toLowerCase() ===
        "https://961hdi521xwnwujrhbvsqqwm-fast.searchtap.net/v2".toLowerCase()
    ) {
      const body = JSON.parse(data);

      body.typoTolerance = 0;

      let sorting = body.sort;
      sorting.unshift("-in_stock");
      data = JSON.stringify(body);
    }
    send.call(this, data);
    document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
  };
})(XMLHttpRequest);

/* These files are auto-generated, do not modify them. If you wish to modify certain assets, please use the sq-custom.css / sq-custom.js file */

window.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".sq-price").forEach((e) => {
    let text = e.innerText;
    if (text.includes(".")) {
      text = text.replace(".", ",");
      text = text + " EUR";
      e.innerText = text;
    }
  });
  document.querySelectorAll(".sq-compare-price").forEach((e) => {
    let text = e.innerText;
    if (text.includes(".")) {
      text = text.replace(".", ",");
      text = text + " EUR";
      e.innerText = text;
    }
  });
});

function toggleFilter() {
  let x = document.querySelector(".sq-filter-main");
  x.classList.toggle("opening");
}
function toggleClass() {
  let y = document.querySelector(".sq-filter-main");
  y.classList.remove("opening");
}
function removeClass() {
  let z = document.querySelector(".sq-filter-main");
  z.classList.remove("opening");
}

window.sq = window.sq || {};

window.sq.initSearch = (store) => {
  store.search();
};

window.addEventListener("load", () => {
  document
    .querySelectorAll(`.sq-filter-group.sq-topbar > div`)
    .forEach((el) => {
      el.addEventListener("mouseenter", (e) => {
        const dropdownBody = e.target.querySelector(".sq-dropdown-body");
        if (dropdownBody) {
          dropdownBody.classList.add("sq-opened");
          dropdownBody.style.maxHeight = "300px";
        }
      });
      el.addEventListener("mouseleave", (e) => {
        const dropdownBody = e.target.querySelector(".sq-dropdown-body");
        if (dropdownBody) {
          dropdownBody.classList.remove("sq-opened");
          dropdownBody.style.maxHeight = "0px";
        }
      });
    });
});

window.sq.getstore = (store) => {
  console.log(store);
};

// setTimeout(()=>{
//  if(window.innerWidth<=767){
//     window.sq.config.themeSettings.topBarFilters = false;
//  }
// },100)

window.sq.onData = (item) => {
  setPrice(item);
  return true;
};

function setPrice(item) {
  fetch(`https://pandorastore.lt/products/${item.handle}.json`)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok " + response.statusText);
      }
      return response.json();
    })
    .then((data) => {
      let product = data.product;
      let sparqCard = document.querySelector(
        `.sparq-card[product-handle="${item.handle}"]`
      );
      let productPrice = parseFloat(product.variants[0].price);
      let productCompareAtPrice = parseFloat(product.variants[0].compare_at_price);
      let price = sparqCard.querySelector(".sq-price");
      let compare_at_price = sparqCard.querySelector(".sq-compare-price");
      let discount = sparqCard.querySelector(".sq-discount-text");
      let discountLabel = sparqCard.querySelector(".discount-label");
      
      if (
        parseFloat(product.variants[0].compare_at_price) >
        parseFloat(product.variants[0].price)
      ) {
        if(discountLabel && item.in_stock < 1) discountLabel.style.display = "none";
        let sqsyprice = sparqCard.querySelector(".sq-sy-price");
        if(sqsyprice) sqsyprice.classList.add("sq-sy-price-has-discount");
        price.innerText =formatPrice(product.variants[0].price);
        compare_at_price.innerText =formatPrice(product.variants[0].compare_at_price);
        discount.innerText = `(-${Math.floor(((productCompareAtPrice - productPrice) / productCompareAtPrice) * 100)}%)`;
      } else {
        compare_at_price.style.display = "none";
        discount.style.display = "none";
        price.innerText =formatPrice(product.variants[0].price);
        if(discountLabel) discountLabel.style.display = "none";
      }
    })
    .catch((error) => {
      console.error(
        "There has been a problem with your fetch operation:",
        error
      );
    });
}
function formatPrice(number){
  
  return (number.replace(".",",")) +' €';
}
// function formatPrice(number){
  
//   return '€'+(number.replace(".",",")) +' EUR';
// }
